import gql from 'graphql-tag';

/**
 * deleteItem(
itemId: String!
): String!
 */
export const deleteItemMutation = gql`
  mutation DeleteItem($itemId: String!) {
    deleteItem(itemId: $itemId)
  }
`;

/**
 * updateItem(
updateItemInput: UpdateItemInput!
): Item!
 */
export const updateItemMutation = gql`
  mutation UpdateItem($updateItemInput: UpdateItemInput!) {
    updateItem(updateItemInput: $updateItemInput) {
      _id
    }
  }
`;

/**
 * createItem(
createItemInput: CreateItemInput!
): Item!
 */
export const createItemMutation = gql`
  mutation CreateItem($createItemInput: CreateItemInput!) {
    createItem(createItemInput: $createItemInput) {
      _id
    }
  }
`;

/**
 * createSingleItem(
createItemInput: CreateItemInput!
): Item!
 */
export const createSingleItemMutation = gql`
  mutation CreateSingleItem($createItemInput: CreateItemInput!) {
    createSingleItem(createItemInput: $createItemInput) {
      _id
    }
  }
`;

